"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortingItemToAggregatedProductMeasureUnitsSortMap = exports.sortingItemToAggregatedProductMeasuresSortMap = void 0;
const graphql_1 = require("../../../__generated__/graphql");
const models_1 = require("../../models");
exports.sortingItemToAggregatedProductMeasuresSortMap = {
    [models_1.SortingItem.SortByTextAsc]: [{ dimension: graphql_1.OrderBy.Asc }],
    [models_1.SortingItem.SortByTextDesc]: [{ dimension: graphql_1.OrderBy.Desc }],
    [models_1.SortingItem.SortByProductCountsAsc]: [{ productCount: graphql_1.OrderBy.Asc }],
    [models_1.SortingItem.SortByProductCountsDesc]: [{ productCount: graphql_1.OrderBy.Desc }],
};
exports.sortingItemToAggregatedProductMeasureUnitsSortMap = {
    [models_1.SortingItem.SortByTextAsc]: [{ unit: graphql_1.OrderBy.Asc }],
    [models_1.SortingItem.SortByTextDesc]: [{ unit: graphql_1.OrderBy.Desc }],
    [models_1.SortingItem.SortByProductCountsAsc]: [{ productCount: graphql_1.OrderBy.Asc }],
    [models_1.SortingItem.SortByProductCountsDesc]: [{ productCount: graphql_1.OrderBy.Desc }],
};
